import Chip from "@mui/material/Chip";

interface ScopeChipProps {
  /** null for a global record, shared by every tenant. */
  tenantId: string | null;
  tenantName?: string;
}

/** Whether a record is global or belongs to one tenant (named when known). */
export default function ScopeChip({ tenantId, tenantName }: ScopeChipProps) {
  return tenantId === null ? (
    <Chip size="small" variant="outlined" label="Global" />
  ) : (
    <Chip size="small" variant="outlined" color="primary" label={tenantName ?? "Tenant"} />
  );
}
